var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-flex"},[_c('code',[_vm._v("Bing: "),_c('b',[_vm._v(_vm._s(_vm.pst))]),_vm._v(" | Yahoo: "),_c('b',[_vm._v(_vm._s(_vm.utc))])])])}
var staticRenderFns = []

export { render, staticRenderFns }